module.exports = __webpack_public_path__ + "img/icon-product-not-found.97ac7c10.svg";